import { FeedbackCard } from './feedback-card';

import type { FeedbackState } from '@agavi/blocks';
import type { Editor } from '@tiptap/react';
/**
 * A locked sensor card, identical on all three sensor blocks.
 *
 * Three copies of this existed (one per accuracy state) and No Sensor Data would have made six.
 * They differ in exactly two things — which state, and what the locked label says — so those are
 * the arguments and everything else is shared: the neutral/incorrect cycler, the content write,
 * the editor wiring.
 */
export function SensorFeedbackCard({ state, label, onChange, activeEditorRef, setActiveEditor, getTitle }: {
  state: FeedbackState;
  label: string;
  onChange: (patch: Partial<FeedbackState>) => void;
  activeEditorRef: React.MutableRefObject<Editor | null>;
  setActiveEditor: (e: Editor | null) => void;
  getTitle: (s: FeedbackState) => string;
}) {
  // Never `correct`: a reading the device could not vouch for is not a right answer, whatever the
  // number says. Same two-state cycle the accuracy cards have always had.
  const ORDER = ['neutral', 'incorrect'] as const;
  const current = state.evaluation === 'correct' ? 'neutral' : state.evaluation as 'neutral' | 'incorrect';
  return (
    <FeedbackCard fieldId={state.id}
      title={getTitle(state)} content={state.content} evaluation={state.evaluation}
      locked evalLocked={false}
      lockedTriggerLabel={label}
      onTitleChange={() => {}} onDelete={() => {}}
      onContentChange={html => onChange({ content: html })}
      onEvaluationCycle={() => onChange({ evaluation: ORDER[(ORDER.indexOf(current) + 1) % ORDER.length]! })}
      activeEditorRef={activeEditorRef}
      setActiveEditor={setActiveEditor}
    />
  );
}
